(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-text-show-more-toggle]');
    if (!button) return;

    var container = button.closest('[data-show-more="true"]');
    if (!container) return;

    var content = container.querySelector('[data-text-content]');
    if (!content) return;

    var expanded = content.classList.toggle('is-expanded');
    button.textContent = expanded
      ? button.dataset.labelLess || 'Voir moins'
      : button.dataset.labelMore || 'Voir plus';
  });
  } catch(e) { console.error(e); }
})();

})();
